import React, { Component } from "react";

import TmxRow from "./TmxRow";

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

class TmxList extends Component {
	

	constructor(props) {
        super(props);
		this.state= {
			page: 0,
			rowsPerPage: 25,
			expandCutomer: false
		}
		
		this.handleExpandCutomer=this.handleExpandCutomer.bind(this);
		this.handleFirstPageButtonClick=this.handleFirstPageButtonClick.bind(this);
		this.handleBackButtonClick=this.handleBackButtonClick.bind(this);
		this.handleNextButtonClick=this.handleNextButtonClick.bind(this);
		this.handleLastPageButtonClick=this.handleLastPageButtonClick.bind(this);
		this.handleChangePage=this.handleChangePage.bind(this);
		this.handleChangeRowsPerPage=this.handleChangeRowsPerPage.bind(this);
    }
	
	handleExpandCutomer(event) {
		this.setState({expandCutomer: event.target.checked});
	}
	
	handleFirstPageButtonClick(event) {
		this.setState({page: 0});
	}
	
	handleBackButtonClick(event) {
		this.setState({page: this.state.page-1});
	}
	
	handleNextButtonClick(event) {
		this.setState({page: (this.state.page+1 > Math.max(0, Math.ceil(this.props.tmxs.length / this.state.rowsPerPage) - 1)) ? this.state.page : this.state.page+1});
	}
	
	handleLastPageButtonClick(event) {
		this.setState({page: Math.max(0, Math.ceil(this.props.tmxs.length / this.state.rowsPerPage) - 1)});
	}
  
	handleChangePage(event, newPage) {
		this.setState({page: newPage});
	}
	
	handleChangeRowsPerPage(event) {
		this.setState({ rowsPerPage: parseInt(event.target.value, 10),
						page: 0
		});
	}

	render() {
//		console.log('render [CustomerList STATE]: ' + JSON.stringify(this.state));
//		console.log('render [CustomerList PROPS.tmxs.length]: ' + JSON.stringify(this.props.tmxs.length));
		const rows = [];
		var tmx;
		var customers;
		var listItems;
    	if(this.props.tmxs && this.props.tmxs.length>0){
			for (var j = this.state.rowsPerPage*this.state.page; (j < (this.state.rowsPerPage*(this.state.page+1))) && (j<this.props.tmxs.length); j++) {
				customers="";
				listItems="";
				tmx = this.props.tmxs[j];
//				console.log(tmx);
				if(tmx.customers!=null){
					if(this.state.expandCutomer){
						listItems = tmx.customers.map((customer) => <li>{customer.name}</li>);
						listItems = <ul>{listItems}</ul>;
					}else{
						//listItems = tmx.customers.map((customer) => customers+=customer.name+", ");
						//customers+=tmx.customer.name+", "
						tmx.customers.forEach((customer) => {
							listItems+=customer.name+", ";
						});
						if(listItems.length>75){
							listItems = listItems.substring(0, 75)+" ...";
						}
					}
				}
				
				let links = tmx.links.find(function(l){return l.rel=="self";});
				rows.push(
				<TmxRow
					key={tmx.id}
					id={tmx.id}
					name={tmx.description}
					languages={tmx.languagePair.code}
					customers={listItems}
					links = {links}
					validation = {tmx.validation}
					actions={this.props.tmxActions}
					accessToken={this.props.accessToken}/>
				);
			}
		}
		
		return (
		  <Table className="lst">
		    <TableHead>
		      <TableRow>
		        <TableCell>Id</TableCell>
				<TableCell>TMX name</TableCell>
				<TableCell>Languages</TableCell>
				<TableCell>
					<FormControlLabel
						control={<Switch
										size="small"
										checked={this.state.expandCutomer}
										onChange={this.handleExpandCutomer}
										value="expandCutomer"
								/>}
						labelPlacement="start"
						label="Customers"
						label={<Typography style={{fontFamily: "'Lato', sans-serif", fontSize: "14px"}}>Customers</Typography>}
					/>
				</TableCell>
				<TableCell>Actions</TableCell>
		      </TableRow>
		    </TableHead>
		    <TableBody>{rows}</TableBody>
		    <TableFooter>
              <TableRow>
                <TablePagination
                  colSpan={5}
                  count={this.props.tmxs.length}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
		  </Table>
		);
  }
};

export default TmxList;